module.exports = __webpack_public_path__ + "img/cover-image.03d2dcd2.jpg";